const $ = require('lib/jquery')

function detectImageSize(url) {
    // loads an image url and detects its size
    // returns a promise that will be resolved with { width, height }

    const deferred = new $.Deferred()
    const dims = {}

    // temporary image for measuring dimensions
    const img = $('<img />').css({
        opacity: 0,
        position: 'absolute',
    })

    // apply load/error handlers
    img.on('load', () => {
        dims.width = img.width()
        dims.height = img.height()
        deferred.resolve(dims)
    })
    img.on('error', () => {
        deferred.reject(dims)
    })

    // append the image and load the url
    img.appendTo('body').attr('src', url)

    // clean up image mess
    deferred.done(() => {
        img.off()
        img.remove()
    })

    return deferred.promise()

}

module.exports = detectImageSize
